import { APIEnvs } from '@smiles/voebiz-core-engine/dist/types';

declare global {
  interface Window {
    smlsEnv: string;
    isDotEnv: boolean;
  }
}
const smilesPortalRegex = /voebiz(-|\.)(.*)\.smiles/;

export const getEnvFromHost = (hostName = window.location.hostname): APIEnvs => {
  if (process.env.NODE_ENV === 'development') {
    return 'HML5';
  }
  const matches = smilesPortalRegex.exec(hostName);
  if (matches === null || matches[2].includes('blue') || matches[2].includes('green')) {
    return 'PRD';
  }
  const isDotEnv = matches[1] === '.';
  let env = matches[2].toUpperCase().replace('UAT', 'HML');
  if (isDotEnv) {
    env += '-N';
  }
  return env as APIEnvs;
};
